// initial values for login:
export const loginInitialValues = {
    email: '',
    password: '',
}

// initial values for forgot password:
export const forgotPasswordInitialValues = {
    email: '',
}

//  initial values for create new password:
export const createNewPasswordInitialValues = {
    password: '',
    confirmPassword: '',
}

// initial values for add hospital:
export const addProgramListInitialValues = {
    phase_type_id: '',
    code: '',
}

export const cryoInitialsValue = {
  total_lsm:'',
  blood_bags:[{identifier:1,volume:100,print_count:0,cd3_count:'',storage_location_id:''}]
}
export const addTerminate = {
    reason: '',
    reason_id:'',
    remarks: '',
}
export const addPool = {
    reason_id: '',
}
// initial values for add hospital:
export const addHospitalInitialValues = {
    hospitalName: "",
    hospitalCode: "",
    hospitalAddress: "",
    country: "",
    state: "",
    city: "",
    cityCode: "",
    pincode: "",
}
// send messaget input:
export const sendMessageInputInitialValue = {
    message: ""
}

// initial values for add User-Management
export const addUserValues = {
    userType: "",
    name: "",
    email: "",
    countryCode: "91",
    phoneNumber: "",
    selectTrial: "",
    hospital: "",
    trial: [],
    principalInvestigator: "",
    slug: ""
};

// initial values for add ImmunoAct QA
export const addIAQAValues = {
    userType: "3",
    name: "",
    email: "",
    countryCode: "91",
    phoneNumber: "",
    selectTrial: "",
};

// initial values for add Trial Manger
export const addTrialManagerValues = {
    userType: "4",
    name: "",
    email: "",
    countryCode: "91",
    phoneNumber: "",
    selectTrial: "",
};

// initial values for add Principal-Investigator
export const addPrincipalInvestigatorValues = {
    name: "",
    email: "",
    countryCode: "91",
    phone: "",
    role_id: 2,
    hospital: ""
}

// initial values for add Disease-Management
export const addDiseaseManagementValues = {
    diseaseName: "",
    description: "",
}

// initial values for add Editor-Management
export const addEditorValues = {
    name: "",
    email: "",
    countryCode: "91",
    phoneNumber: "",
    trial: [],
    principalInvestigator: ""
}

// initial values for add Trial-Management
export const resendTrialManagementValues = {
    description: "",
    terms: false
}

export const AddNewSubject = {
    first_name: "",
    last_name: "",
    gender: "",
    dob: "",
    disease: "",
    disease_id:'',
    form_template: "",
    upload_file: "",
    investigator_id: '',
    editor_id: '' ,

}

export const AddNewSubjectPhase = {
    first_name: "",
        last_name: "",
        gender: "",
        dob: "",
        disease_id:'',
        investigator_id: '',
        editor_id: '' ,
        upload_file: ""
}

export const EditSubjectPhase = {
        first_name: "",
        last_name: "",
        gender: "",
        dob: "",
        phase_id: '',
        investigator_id: '',
        editor_id: ''  ,
        disease_id:'',
        phase_code:'',
        phase_title:'',
        addCycle :'',
}
export const exportFormCsv = {
    formId: "",
    questionId: []
}

// Edit subject id schema 
export const editSubjectId = {
    patientId: ""
}

export const ReAssignPiEditor = {
    principal_investigator: "",
    editor_id: "",
}

export const AddProduct = {
    program_code:"",
    productName: "",
    description: ""
}


export const AddPhase = {
    phase_code:"",
    title: "",
    phase_type: "",
    phase_start_date: "",
    minimum_subjects: "",
    coordinating_PI_id: "",
    description:"",
    // template_type_ids: [],
};
export const VisitFrequency={}

export const EditPhase = {
    product_id: "",
    title: "",
    phase_type: "",
    minimum_subjects: "",
    phase_start_date: "",
    coordinating_PI_id: "",
    qa_ids: [],
    manager_ids: [],
    template_type_ids: [],
    form_template_ids: [],
    investigator_ids: [],
    description:"",

}
export const PendingTasks = {
    category: null,
    product: null,
    phase_id: null,
    role:null
};

export const AddFormTemplate = {
    title: "",
    type: "",
    description: ""
}

export const addPiSubjectValues = {
    name: "",
    gender: "",
    dob: "",
}

export const reAssignValues = {
    editor_id: ''
}

export const updatePhaseValues = {
    phase: []
}

export const queryMessage = {
    phase: "",
    template: "",
    formField: "",
}

export const deadDateValue ={
    deathDateValue: "",
    description: ""
}

export const FollowUpLostDateValue ={
    lostToFollowUp: "",
    description: ""
}

export const patientIdValue ={
    patientId: ""
}

// initial values for add form types
export const addFormType = {
    prefix:"",
    typeName: ""
}

export const requestChangeInitial ={
    description: "",
    Select_patient_request_status:"",
    Select_patient_Info_menu: ""
}

export const initialForProductMaster = {
        product_ids: [],
        description: "",
        active: true,
        lsm_received_ed: "",
        lsm_qualification_ed: "",
        manufacturing_completion_ed: "",
        qc_testing_ed: "",
        qa_review_ed: "",
        expiry_date: "",
        cryo_manufacturing_date: "",
        cryo_manufacturing_completion_ed: "",
        cryo_qc_testing_ed: "",
        cryo_qa_review_ed: "",
}